import {
  FaBed,
  FaBath,
  FaRulerCombined,
  FaBuilding,
  FaMoneyBillWave,
  FaHandshake,
  FaCalendarAlt,
} from "react-icons/fa";
import { MdBalcony, MdDateRange, MdOutlineCurrencyRupee } from "react-icons/md";
import { TbStairsUp } from "react-icons/tb";
import { GiSandsOfTime, GiMoneyStack, GiStairs } from "react-icons/gi";
import { BsFillHouseHeartFill } from "react-icons/bs";
import { PiSignpostBold } from "react-icons/pi";
import { RiBuilding2Fill } from "react-icons/ri";
import { FaCity } from "react-icons/fa";
import { GiModernCity } from "react-icons/gi";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { BsFillBuildingFill } from "react-icons/bs";
import { VscTypeHierarchySub } from "react-icons/vsc";

export const DYNAMIC_FEATURES = [
   {
    key: "purpose",
    label: "Listing Type",
    icon: <BiSolidPurchaseTag size={22} color="red" />,
  }, {
    key: "propertyType",
    label: "Building Type",
    icon: <RiBuilding2Fill size={22} color="red" />,
  }, {
    key: "propertySubType",
    label: "Property Type",
    icon: <VscTypeHierarchySub size={22} color="red" />,
  },
   {
    key: "project",
    label: "Project",
    icon: <BsFillBuildingFill size={22} color="red" />,
  },
   {
    key: "locality",
    label: "Locality",
    icon: <GiModernCity size={22} color="red" />,
  },
   {
    key: "city",
    label: "City",
    icon: <FaCity size={22} color="red" />,
  },
  { key: "bedrooms", label: "Bedrooms", icon: <FaBed size={22} color="red" /> },
  {
    key: "bathrooms",
    label: "Bathrooms",
    icon: <FaBath size={22} color="red" />,
  },
  {
    key: "balconies",
    label: "Balconies",
    icon: <MdBalcony size={24} color="red" />,
  },
  {
    key: "builtupArea",
    label: "Built-up Area",
    icon: <FaRulerCombined size={20} color="red" />,
  },
  {
    key: "floorNo",
    label: "Floor No.",
    icon: <TbStairsUp size={22} color="red" />,
  },
  {
    key: "totalFloors",
    label: "Total Floors",
    icon: <FaBuilding size={20} color="red" />,
  },
  {
    key: "floorNumber",
    label: "Property on Floor",
    icon: <GiStairs size={22} color="red" />,
  },

  {
    key: "possession",
    label: "Possession",
    icon: <MdDateRange size={22} color="red" />,
  },
  {
    key: "furnishingStatus",
    label: "Furnishing Status",
    icon: <BsFillHouseHeartFill size={22} color="red" />,
  },
  {
    key: "availabilityStatus",
    label: "Availability Status",
    icon: <FaHandshake size={22} color="red" />,
  },
  {
    key: "saleType",
    label: "Sale Type",
    icon: <FaMoneyBillWave size={22} color="red" />,
  },
  {
    key: "sides",
    label: "Sides Facing",
    icon: <PiSignpostBold size={22} color="red" />,
  },
  {
    key: "willingTo",
    label: "Willing To",
    icon: <FaHandshake size={22} color="red" />,
  },
  {
    key: "bookingAmount",
    label: "Booking Amount",
    icon: <MdOutlineCurrencyRupee size={22} color="red" />,
  },
  {
    key: "maintenance",
    label: "Maintenance Cost",
    icon: <GiMoneyStack size={22} color="red" />,
  },
  {
    key: "ageOfProperty",
    label: "Age of Property",
    icon: <GiSandsOfTime size={22} color="red" />,
  },
];

export const RESIDENTIAL_TYPES = Object.freeze([
  "1 RK / Studio Apratment",
  "Flats / Apartments",
  "Builder Floor",
  "Land / Plot",
  "Penthouse",
  "Studio",
  "Independent House / Villa",
  "Farmhouse",
]);
export const COMMERCIAL_TYPES = Object.freeze([
  "Office",
  "Warehouse/Godown",
  "Shop",
  "Commercial Land / Plot",
  "Factory",
  "Showroom",
]);

export const PROPERTY_TYPES = Object.freeze([
  "Flats / Apartments",
  "Independant House/Villa",
  "Office",
  "Shop",
  "Land/Plot",
  "Builder Floor",
]);

export const PROPERTY_PURPOSES = Object.freeze([
  "Buy",
  "Rent/Lease",
  "PG",
  "New Launch",
  "Commercial",
  "Plot/Land",
  "Projects"
]);
export const WILLING_TO = Object.freeze([
  "Family",
  "Single Men",
  "Single Women",
]);
export const OWNERSHIP_TYPES = Object.freeze([
  "Freehold",
  "Leasehold",
  "Power of Attorney",
  "Co-operative Society",
]);

export const PANTRY_TYPE = Object.freeze([
  "Private",
  "Shared",
  "Not - Available",
]);

export const CONFERENCE_ROOMS = Object.freeze(["Available", "Not - available"]);
export const FURNISHING_STATUS = Object.freeze([
  "Furnished",
  "Semi-Furnished",
  "Unfurnished",
]);
export const BHK = Object.freeze(["1BHK" , "2BHK", "3BHK", "4BHK", "5BHK", "6BHK +"]);
export const BATHROOMS = Object.freeze(["1", "2", "3", "4", "5", "6 +"]);
export const BALCONIES = Object.freeze(["0", "1", "2", "3", "4", "5 +"]);
export const ADDITIONAL_ROOMS = Object.freeze([
  "Pooja Room",
  "Study Room",
  "Servant Room",
  "Other Room",
]);

export const POSSESSION_BY = Object.freeze([
  "Within 3 months",
  "Within 6 months",
  "By 2025",
  "By 2026",
  "By 2027",
  "By 2028",
  "By 2029",
]);

export const TOTAL_FLOORS = Object.freeze(["1", "2", "3", "4", "5", "6"]);

export const FLOOR_NUMBER = Object.freeze([
  "Basment",
  "Ground",
  "1st",
  "2nd",
  "3rd",
  "4th",
]);

export const SALE_TYPE = Object.freeze(["Resale", "New Property"]);

export const UNITS = Object.freeze([
  "sq.ft.",
  "sq.yards",
  "sq.m.",
  "acres",
  "marla",
  "cents",
]);

export const ROOM_TYPE = Object.freeze([
  "Private",
  "Twin Sharing",
  "Tripple Sharing",
  "Quad Sharing",
]);

export const SUITABLE_FOR = Object.freeze([
  "Student",
  "Working Professionals",
  "Both",
]);

export const AVAILABLE_FOR = Object.freeze(["Boys", "Girls", "Both"]);

export const AMENITIES = Object.freeze([
  "Swimming Pool",
  "Gym",
  "Parking",
  "Garden",
  "Play Area",
  "Security",
  "Clubhouse",
  "Power Backup",
  "Lift",
  "CCTV Surveillance",
  "Intercom Facility",
  "Fire Safety",
  "Jogging Track",
  "Rainwater Harvesting",
  "Children's Park",
  "Community Hall",
  "Waste Disposal",
  "Wi-Fi Connectivity",
  "Indoor Games Room",
  "Spa & Sauna",
  "Tennis Court",
  "Basketball Court",
  "Badminton Court",
  "Visitor Parking",
  "Laundry Service",
  "24/7 Water Supply",
  "Gated Community",
  "Solar Water Heating",
  "Library",
  "Shopping Complex",
  "ATM",
  "Pet Friendly",
  "Barbecue Area",
]);

export const PRICE_RANGE = Object.freeze([
  { value: 100000, label: "₹1L" },
  { value: 300000, label: "₹3L" },
  { value: 500000, label: "₹5L" },
  { value: 750000, label: "₹7.5L" },
  { value: 1000000, label: "₹10L" },
  { value: 1500000, label: "₹15L" },
  { value: 2000000, label: "₹20L" },
  { value: 2500000, label: "₹25L" },
  { value: 3000000, label: "₹30L" },
  { value: 4000000, label: "₹40L" },
  { value: 5000000, label: "₹50L" },
  { value: 7500000, label: "₹75L" },
  { value: 10000000, label: "₹1Cr" },
  { value: 15000000, label: "₹1.5Cr" },
  { value: 20000000, label: "₹2Cr" },
  { value: 25000000, label: "₹2.5Cr" },
  { value: 30000000, label: "₹3Cr" },
  { value: 35000000, label: "₹3.5Cr" },
  { value: 40000000, label: "₹4Cr" },
  { value: 45000000, label: "₹4.5Cr" },
  { value: 50000000, label: "₹5Cr" },
  { value: 55000000, label: "₹5.5Cr" },
  { value: 60000000, label: "₹6Cr" },
  { value: 65000000, label: "₹6.5Cr" },
  { value: 70000000, label: "₹7Cr" },
  { value: 75000000, label: "₹7.5Cr" },
  { value: 80000000, label: "₹8Cr" },
  { value: 85000000, label: "₹8.5Cr" },
  { value: 90000000, label: "₹9Cr" },
  { value: 95000000, label: "₹9.5Cr" },
  { value: 100000000, label: "₹10Cr" },
  { value: 200000000, label: "₹20Cr" },
  { value: 400000000, label: "₹40Cr" },
  { value: 700000000, label: "₹70Cr" },
  { value: 1000000000, label: "₹100Cr" },
]);
//Nav Links
export const navStructure = Object.freeze([
  {
    label: "Buyers",
    subItems: [
      {
        label: "Property for sale in Noida",
        path: "/search-results?city=Noida&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Ghaziabad",
        path: "/search-results?city=Ghaziabad&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Delhi",
        path: "/search-results?city=Delhi&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Mumbai",
        path: "/search-results?city=Mumbai&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Greater Noida",
        path: "/search-results?city=Greater Noida&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Goa",
        path: "/search-results?city=Goa&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Gurgaon",
        path: "/search-results?city=Gurgaon&propertySubType=&purpose=sale",
      },
      {
        label: "Property for sale in Bengaluru",
        path: "/search-results?city=Bengaluru&propertySubType=&purpose=sale",
      },
    ],
  },
  {
    label: "Owners",
    subItems: [
      { label: "Post Property", path: "/post-properties/basic-info" },
      { label: "My Listings", path: "/user-profile/listing" },
      { label: "Responses", path: "/user-profile/responses" },
    ],
  },
  {
    label: "Tenants",
    subItems: [
      {
        label: "Property for rent in Noida",
        path: "/search-results?city=Noida&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Ghaziabad",
        path: "/search-results?city=Ghaziabad&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Delhi",
        path: "/search-results?city=Delhi&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Mumbai",
        path: "/search-results?city=Mumbai&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Greater Noida",
        path: "/search-results?city=Greater Noida&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Goa",
        path: "/search-results?city=Goa&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Gurgaon",
        path: "/search-results?city=Gurgaon&propertySubType=&purpose=rent/lease",
      },
      {
        label: "Property for rent in Bengaluru",
        path: "/search-results?city=Bengaluru&propertySubType=&purpose=rent/lease",
      },
    ],
  },
  {
    label: "Builders / Dealers",
    subItems: [
      { label: "Post Project", path: "/post-properties/basic-info" },
      { label: "My Listings", path: "/user-profile/listing" },
      { label: "Responses", path: "/user-profile/responses" },
    ],
  },
  {
    label: "Projects",
    subItems: [
      { label: "Explore Projects", path: "/projects/explore" },
      { label: "Top Rated Projects", path: "/projects/top-rated" },
      { label: "Upcoming Projects", path: "/projects/upcoming" },
      { label: "Luxury Projects", path: "/projects/luxury" },
      { label: "Affordable Projects", path: "/projects/affordable" },
      { label: "New Launches", path: "/projects/new-launches" },
      { label: "Compare Projects", path: "/projects/compare" },
    ],
  },
]);

export const allCities = Object.freeze([
  "Agra",
  "Ahmedabad",
  "Aizawl",
  "Aligarh",
  "Amritsar",
  "Aurangabad",
  "Bangalore",
  "Bareilly",
  "Belgaum",
  "Bhavnagar",
  "Bhopal",
  "Bilaspur",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Dehradun",
  "Delhi",
  "Goa",
  "Dhanbad",
  "Faridabad",
  "Gangtok",
  "Ghaziabad",
  "Guntur",
  "Gurgaon",
  "Gwalior",
  "Howrah",
  "Hubli",
  "Hyderabad",
  "Imphal",
  "Indore",
  "Itanagar",
  "Jaipur",
  "Jabalpur",
  "Jamshedpur",
  "Jodhpur",
  "Kanpur",
  "Kochi",
  "Kolhapur",
  "Kolkata",
  "Kota",
  "Lucknow",
  "Ludhiana",
  "Madurai",
  "Meerut",
  "Moradabad",
  "Mumbai",
  "Mysore",
  "Nanded",
  "Nashik",
  "Nellore",
  "Nagpur",
  "Panaji",
  "Patna",
  "Port Blair",
  "Prayagraj",
  "Pune",
  "Raipur",
  "Rajkot",
  "Ranchi",
  "Salem",
  "Shimla",
  "Shillong",
  "Siliguri",
  "Srinagar",
  "Surat",
  "Thane",
  "Tiruchirappalli",
  "Tirupati",
  "Udaipur",
  "Varanasi",
  "Vadodara",
  "Vijayawada",
  "Visakhapatnam",
  "Warangal"
]);

export const popularCities = Object.freeze( [
  "Noida",
  "Delhi",
  "Greater Noida",
  "Ghaziabad",
  "Mumbai",
  "Kolkata",
  "Bangalore",
  "Pune",
  "Hyderabad",
  "Chennai",
  "Gurgaon",
  "Thane",
  "Ahmedabad"
]);
const PROPERTY_CONSTANTS = {
  PROPERTY_TYPES,
  PROPERTY_PURPOSES,
  OWNERSHIP_TYPES,
  FURNISHING_STATUS,
  ADDITIONAL_ROOMS,
  POSSESSION_BY,
  TOTAL_FLOORS,
  FLOOR_NUMBER,
  SALE_TYPE,
  AMENITIES,
  WILLING_TO,
  ROOM_TYPE,
  AVAILABLE_FOR,
  SUITABLE_FOR,
  DYNAMIC_FEATURES,
  BATHROOMS,
  BHK,
  BALCONIES,
  PRICE_RANGE,
  allCities,
  popularCities
};

export default PROPERTY_CONSTANTS;
